  <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onTabIndexChanged($event)">
    <mat-tab [label]="'CAR_MARKET.TITLE' | translate">
      <div class="banner-top" [class.car-container-desktop]="!isMobileView()"
        [class.car-container-mobile]="isMobileView()" *ngIf="false">
        <!--  <img src="assets/images/uae_banner_cars_scaled.png" alt="logo" class="logo">-->
        <div>
          <img src="/assets/images/uae_banner_scaled.png" class="logo">
        </div>
        <div style="width: 200px">
          <img src="/assets/images/collage.png" class="logo">
        </div>
      </div>
      <div [@fadeAnimation] class="content-container">


        <div class="layout-container">
          <div
            [ngClass]="isMobileView() ? 'filter-container-mobile' : 'filter-container'"
            [class.collapsed]="isFilterCollapsed"
            [ngStyle]="{ 'top.px': !isMobileView() ? (isLoggedIn ? 200 : 140) : null }">

            <div class="filter-section slider-height" dir="rtl">
              <label for="year">{{ 'CAR_MARKET.PRICE_RANGE' | translate }}:</label>
              <div class="slider-range-values">
                <span></span>
                <span>{{ currencyService.convertFromIls(sliderValue) | currency: currencyService.code : currencyService.symbol : '1.0-0' }}</span> -
                <span>{{ currencyService.convertFromIls(sliderHighValue) | currency: currencyService.code : currencyService.symbol : '1.0-0' }}</span>
                <span></span>
              </div>
              <div class="custom-slider">
                <ngx-slider [(value)]="sliderValue" [(highValue)]="sliderHighValue" [options]="sliderOptions"
                  (userChangeEnd)="onSliderChangeEnd($event)"></ngx-slider>
              </div>
            </div>


            <!--      <div class="filter-section">-->
            <!--        <label for="year">שנה:</label>-->
            <!--        <select id="year" name="year" (change)="onYearChange($event.target.value)">-->
            <!--          <option *ngFor="let year of filterMetaYears" [value]="year">{{ year }}</option>-->
            <!--        </select>-->
            <!--      </div>-->
            <div class="filter-section">
              <label for="make">{{ 'CAR_MARKET.MANUFACTURER' | translate }}:</label>
              <select id="make" name="make" [value]="selectedMake" (change)="onMakeChange($event.target.value)">
                <option *ngFor="let make of makes" [value]="make">{{ displayMake(make) }}</option>
              </select>
            </div>
            <div class="filter-section">
              <label for="model">{{ 'CAR_MARKET.MODEL' | translate }}:</label>
              <select id="model" name="model" [value]="selectedModel" (change)="onModelChange($event.target.value)"
                class="model-select">
                <option *ngFor="let model of models" [value]="model" class="model-select">{{ displayModel(model) }}</option>
              </select>
            </div>
            <div class="filter-section">
              <label for="fuel">{{ 'CAR_MARKET.VEHICLE_TYPE' | translate }}:</label>
              <select id="fuel" name="fuel" (change)="onFuelChange($event.target.value)">
                <option *ngFor="let fuel of fuelTypes" [value]="fuel">{{ displayFuelType(fuel) }}</option>
              </select>
            </div>
            <div class="filter-section slider-height" dir="rtl">
              <label for="year">{{ 'CAR_MARKET.KM_RANGE' | translate }}:</label>
              <div class="slider-range-values">
                <span></span>
                <span>{{ (sliderKmValue | number) + ' ' + ('CAR_MARKET.KM' | translate) }}</span> -
                <span>{{ (sliderKmHighValue | number) + ' ' + ('CAR_MARKET.KM' | translate) }}</span>
                <span></span>
              </div>
              <div class="custom-slider">
                <ngx-slider [(value)]="sliderKmValue" [(highValue)]="sliderKmHighValue" [options]="sliderKmOptions"
                  (userChangeEnd)="onSliderKmChangeEnd($event)"></ngx-slider>
              </div>
            </div>
            <div *ngIf="!showDirham && localeService.israeliMarket" class="filter-section">
              <label>{{ 'CAR_MARKET.CARS_IN_ISRAEL' | translate }}:</label>
            </div>
            <div *ngIf="!showDirham && localeService.israeliMarket" class="filter-section" style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
              <label style="margin: 0;">
                <input type="radio" name="locatedInIsrael" value="Yes" [(ngModel)]="locatedInIsrael"
                  (change)="onLocationToggleChange($event)"> {{ 'COMMON.YES' | translate }}
              </label>
              <label style="margin: 0;">
                <input type="radio" name="locatedInIsrael" value="No" [(ngModel)]="locatedInIsrael"
                  (change)="onLocationToggleChange($event)"> {{ 'COMMON.NO' | translate }}
              </label>
              <label style="margin: 0;">
                <input type="radio" name="locatedInIsrael" value="All" [(ngModel)]="locatedInIsrael"
                  (change)="onLocationToggleChange($event)"> {{ 'COMMON.ALL' | translate }}
              </label>
            </div>

            <div class="filter-section">
              <label>{{ 'CAR_MARKET.VEHICLE_CONDITION' | translate }}:</label>
            </div>
            <div class="filter-section" style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
              <label style="margin: 0;">
                <input type="radio" name="SaleCondition" value="New" [(ngModel)]="saleCondition"
                  (change)="onCarSaleConditionToggleChange($event)"> {{ 'COMMON.NEW' | translate }}
              </label>
              <label style="margin: 0;">
                <input type="radio" name="SaleCondition" value="Used" [(ngModel)]="saleCondition"
                  (change)="onCarSaleConditionToggleChange($event)"> {{ 'COMMON.USED' | translate }}
              </label>
              <label style="margin: 0;">
                <input type="radio" name="SaleCondition" value="All" [(ngModel)]="saleCondition"
                  (change)="onCarSaleConditionToggleChange($event)"> {{ 'COMMON.ALL' | translate }}
              </label>
            </div>

            <div class="filter-section" *ngIf="!showDirham && localeService.israeliMarket">
              <label>{{ 'CAR_MARKET.SHOW_FOR_VEHICLE' | translate }}:</label>
            </div>
            <div class="filter-section" style="display: flex; flex-direction: row; align-items: center; gap: 10px;"
              *ngIf="!showDirham && localeService.israeliMarket">
              <label style="margin: 0;">
                <input type="radio" name="importType" value="Commercial" [(ngModel)]="importType"
                  (change)="onCarImportTypeToggleChange($event)"> {{ 'COMMON.COMMERCIAL' | translate }}
              </label>
              <label style="margin: 0;">
                <input type="radio" name="importType" value="Taxi" [(ngModel)]="importType"
                  (change)="onCarImportTypeToggleChange($event)"> {{ 'COMMON.TAXI' | translate }}
              </label>
            </div>


            <div class="filter-section filter-section-button">
              <button class="Dialog" mat-raised-button color="warn" appScrollToTop (click)="filter('normal')">
                <i class="fas fa-search"></i> {{ 'CAR_MARKET.FILTER_BUTTON' | translate }}
              </button>
            </div>
            <div class="filter-section filter-section-button">
              <button class="Dialog" mat-raised-button color="primary" (click)="filter('interested')">
                <i class="fas fa-car"></i> {{ 'CAR_MARKET.INTERESTED' | translate }}
              </button>

              <!--        <mat-spinner *ngIf="loading"></mat-spinner>-->
            </div>
            <div class="filter-section filter-section-button">
              <button class="Dialog" mat-raised-button color="primary" (click)="filter('liked')">
                <i class="fas fa-car"></i> {{ 'CAR_MARKET.LIKED' | translate }}
              </button>

              <!--        <mat-spinner *ngIf="loading"></mat-spinner>-->
            </div>
          </div>

          <ng-template #loadingOverlay>
            <div class="loading-overlay">
              <mat-spinner></mat-spinner>
            </div>
          </ng-template>

          <div id="cardContainer" #carContainer [class.car-container-desktop]="!isMobileView()"
            [class.car-container-mobile]="isMobileView()" class="car-container" dir="ltr">

            <div class="card-container">
              <ng-container  *ngFor="let car of cars">
              <mat-card
                *ngIf="car.url"

                [ngClass]="{'card-item-m': isMobileView(), 'card-item': !isMobileView(), 'authorized-border': car.authorized_seller && localeService.israeliMarket, 'regular-border': !car.authorized_seller}"
                matRipple fxLayout="column" fxFlex>
                <!--        <mat-card [ngClass]="isMobileView() ? 'card-item-m' : 'card-item'" *ngFor="let car of cars" matRipple-->
                <!--                  fxLayout="column" fxFlex>-->
                <div style="height: 110px;width: calc(100% + 32px);margin: 0 -16px 0 -16px;"
                  class="car-image-container">
                  <img mat-card-image
                       (error)="car.url = null"
                       class="card-image"
                       [src]="car.url"
                       alt="{{car.Manufacturer}} {{car.Model}}"
                      (click)="openDialog(car)"
                       height="110px" />

                </div>
                <fa-icon class="heart-icon" [icon]="car.isLiked ? fasFaHeart : farFaHeart"
                  (click)="toggleLike(car)"></fa-icon>

                <fa-icon *ngIf="car.myCarId !== null" class="cart-icon" [icon]="faShoppingCart"></fa-icon>

                <!--          <svg-icon *ngIf="car.authorized_seller"-->
                <!--                    class="authorized"-->
                <!--                    [src]="'/assets/icons/certificate.svg'"-->
                <!--                    [svgStyle]="{width:'24px', height:'24px'}"-->
                <!--                    nbTooltip="ספק מאושר"-->
                <!--          ></svg-icon>-->

                <svg-icon *ngIf="car.Location === 'Israel' && localeService.israeliMarket" class="location"
                  [src]="'/assets/icons/countries/'+ (car.Location ? 'israel' : 'israel') +'.svg'"
                  [svgStyle]="{width:'16px'}" [nbTooltip]="'CAR_MARKET.LOCATED_IN_ISRAEL' | translate"></svg-icon>

                <mat-card-content class="mat-card-content">

                  <div class="m-1 pt-3">
                    <div class="overview-style">
                      <div [ngStyle]="{ 'background-color': '#5f7dff', 'border-bottom': '0px' }"
                        class="overview-cart parent-cart">
                        <div class="inner-header flex-row">
                          <!--                    <span class=" mt-4 heading-text white size14" [className]="car.Manufacturer == 'Mercedes-Benz' ? 'size12' : 'size14'">{{ car.Manufacturer }}</span>-->
                          <span class="mt-4 heading-text white"
                            [ngClass]="{ 'size12': car.Manufacturer === 'Mercedes-Benz', 'size14': car.Manufacturer !== 'Mercedes-Benz' }">
                            {{ car.Manufacturer }}
                          </span>
                          <span class="mt-4 heading-id-text size14">{{ car.id }}</span>
                          <img *ngIf="car.IsHot" class="mt-4 hot-icon" src="/assets/images/fire-30.png" alt=""
                            width="25" height="30" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="more-info">
                    <div class="flex-row location-info">
                      <span class="flex-cell location-text mr-4 bold pull-left" style="float:left;">{{
                        getFuelTypeHebrew(car.FuelType) }}</span>
                      <span class="flex-cell location-text mr-4 bold pull-left truncate">{{ car.FinishLevel }}</span>
                      <span class="flex-cell location-text mr-4 bold pull-left truncate" direction="ltr">{{ car.Model
                        }}</span>

                    </div>
                    <div class="extra-info">
                      <div class="flex-table">
                        <div class="flex-row" *ngIf="!showDirham">
                          <!--                  <div class="flex-cell bold">מחיר</div>-->
                          <div *ngIf="importType === 'Commercial'" class="flex-cell bold big price">
                            {{ currencyService.convertFromIls(car.C_Price) | currency: currencyService.code : currencyService.symbol : '1.0-0' }}<br />
                            <span class="small" style="font-size:8pt">
                              {{ 'CAR_MARKET.PRICE_FROM_LAST_UPDATE' | translate }}
                            </span>
                          </div>
                          <div *ngIf="importType === 'Taxi'" class="flex-cell bold big price" style="height:55px">
                            <div
                              style="flex-direction: row; align-items: center; display: flex;justify-content: space-around">
                              <div><img src="/assets/images/Taxi_logo.png" alt="" width="60" height="20"
                                  style="border:2px solid black; border-radius: 4px" /></div>
                              <span>{{ currencyService.convertFromIls(car.C_PriceComTaxi) | currency: currencyService.code : currencyService.symbol : '1.0-0' }}</span>
                            </div>
                            <div style="margin-top: 0px;">
                              <span class="small" style="font-size:8pt">{{ 'CAR_MARKET.ESTIMATED_PRICE' | translate }} </span>
                              <span class="small" style="font-size:9pt; font-weight: bold">{{ 'CAR_MARKET.FOR_TAXI' | translate }}</span>
                              <span class="small" style="font-size:8pt">{{ 'CAR_MARKET.AFTER_CUSTOMS' | translate }} </span>
                            </div>
                          </div>
                        </div>
                        <div class="flex-row" *ngIf="showDirham">
                          <!--                  <div class="flex-cell bold">מחיר</div>-->
                          <div *ngIf="importType === 'Commercial'" class="flex-cell bold big price">
                            {{ getCarPrice(car) |currency: 'AED' : 'symbol' : '1.0-0' }}<br />
                            <span class="small" style="font-size:8pt">
                              Estimated price after customs release
                            </span>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="extra-info-engine">
                      <div class="flex-table">
                        <div class="flex-row bold">
                          <div class="flex-cell">{{ 'CAR_MARKET.YEAR_OF_MANUFACTURE' | translate }}</div>
                          <div class="flex-cell">{{ 'CAR_MARKET.COLOR' | translate }}</div>
                          <div class="flex-cell">{{ 'CAR_MARKET.MILEAGE' | translate }}</div>
                        </div>
                        <div class="flex-row">
                          <div class="flex-cell">{{ car.ManufactureDate | date:'yyyy' }}</div>
                          <div class="flex-cell truncate">{{ car.ExteriorColor }}</div>
                          <div class="flex-cell">{{ car.Mileage | number: '1.0-0' }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="extra-info-engine">
                      <div *ngIf="car.engine" class="flex-row bold engine-text">
                        <div class="flex-cell">{{ 'CAR_MARKET.ENGINE' | translate }}</div>
                        <div class="flex-cell">{{ car.engine }}</div>
                      </div>
                    </div>
                    <div class="extra-info-engine authorized-seller">
                      <div *ngIf="car.authorized_seller && localeService.israeliMarket" class="flex-row bold flex-with-icon">
                        <div class="icon-width">
                          <svg-icon class="authorized" [src]="'/assets/icons/certificate.svg'"
                            [svgStyle]="{width:'24px', height:'24px'}" [nbTooltip]="'CAR_MARKET.AUTHORIZED_SELLER' | translate"></svg-icon>
                        </div>
                        <div class="with-icon">{{ 'CAR_MARKET.AUTHORIZED_SELLER' | translate }}</div>

                      </div>
                    </div>
                  </div>

                  <!--            <div class="ad-id">-->
                  <!--              <div class="flex-table">-->
                  <!--                <div class="flex-row bold">-->
                  <!--                  <div class="flex-cell">{{car.id}}</div>-->
                  <!--                  <div class="flex-cell">מודעה מס</div>-->
                  <!--                </div>-->


                  <!--              </div>-->
                  <!--            </div>-->

                  <div class="card-actions">
                    <button id="cars-grid-more-info-button" mat-raised-button color="primary"
                      class="interested-button full-width" (click)="handleClick(car)">{{ 'CAR_MARKET.MORE_DETAILS' | translate }}
                    </button>
                  </div>
                </mat-card-content>
              </mat-card>
              </ng-container>
              <div class="spinner-container" *ngIf="hasMore">
                <button mat-button class="load-more-button" color="accent" (click)="handleLoadMore()">
                  <mat-icon>expand_more</mat-icon> <!-- Replace 'add' with the icon you want -->
                  {{ 'CAR_MARKET.LOAD_MORE' | translate }}
                </button>
              </div>
            </div>
          </div>
          <button class="filter-toggle-button" (click)="toggleFilter()" *ngIf="isMobileView()">
            <i [ngClass]="isFilterCollapsed ? 'fas fa-filter' : 'fas fa-times'"></i>
            <!-- Switch between filter and close icons -->
          </button>
          <ng-container #host style="display: none"></ng-container>


        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="'CAR_MARKET.COLLECTIBLES' | translate" class="collectible-tab" *ngIf="localeService.israeliMarket">
      <div [@fadeAnimation]>
        <app-cars-grid-coll [selected]="selectedTab == 1"></app-cars-grid-coll>
      </div>
    </mat-tab>
  </mat-tab-group>

